export default "__VITE_ASSET__tZJr4Y8r__"